import { MonitorSmartphone, PenTool, MapPin, Check, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const SERVICES = [
  {
    number: "01",
    icon: MonitorSmartphone,
    title: "Webdesign & Development",
    description:
      "High-Performance, Mobile-First Webseiten & Web-Apps mit klarem Fokus auf Conversion und Geschwindigkeit.",
    features: [
      "Responsive Webdesign & Onepager",
      "Web-Apps & Online-Shops",
      "Core Web Vitals im grünen Bereich",
      "Homepage erstellen in Lüdenscheid & Umgebung",
    ],
  },
  {
    number: "02",
    icon: PenTool,
    title: "Grafik- & Logo Design",
    description:
      "Einzigartige Markenidentitäten, Vektordesigns & Corporate Identities, die im Gedächtnis bleiben.",
    features: [
      "Logo Design für Hagen & Region",
      "Corporate Identity & Styleguides",
      "Print & Geschäftsausstattung",
      "Social Media Templates",
    ],
  },
  {
    number: "03",
    icon: MapPin,
    title: "Marketing & Local SEO",
    description:
      "Zielgerichtete Neukundengewinnung & lokale Sichtbarkeit in Lüdenscheid und Umgebung.",
    features: [
      "Local SEO & Google Business Profil",
      "Google Ads & Meta Ads",
      "Content & Copywriting",
      "Transparentes Reporting",
    ],
  },
];

export const Services = () => {
  return (
    <section id="leistungen" data-testid="services-section" className="relative bg-[#0A0A0A] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="mb-16 max-w-2xl lg:mb-20">
            <p className="mb-4 text-xs font-semibold uppercase tracking-wider text-[#C5A059]">
              LEISTUNGEN
            </p>
            <h2 className="font-heading text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl">
              Drei Säulen für Ihren digitalen Markterfolg
            </h2>
            <p className="mt-5 text-base leading-relaxed text-muted-foreground md:text-lg">
              Strategie, Design und technische Perfektion aus einer Hand — maßgeschneidert für mittelständische Unternehmen in Lüdenscheid und der Region.
            </p>
          </div>
        </Reveal>

        <div className="grid gap-6 md:grid-cols-3">
          {SERVICES.map((service, i) => (
            <Reveal key={service.number} delay={i * 120} className="h-full">
              <article
                data-testid={`service-card-${i + 1}`}
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-[#121212] p-8 transition-[border-color,transform] duration-300 hover:-translate-y-1.5 hover:border-[#C5A059]/50"
              >
                <div className="mb-8 flex items-center justify-between border-b border-white/10 pb-6">
                  <span className="font-heading text-3xl font-light tracking-wider text-[#C5A059]">
                    {service.number}
                  </span>
                </div>

                <h3 className="font-heading text-xl font-semibold leading-snug text-white tracking-tight">{service.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  {service.description}
                </p>

                <ul className="mt-7 space-y-3">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-2.5 text-sm text-foreground/80">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#C5A059]" />
                      {feature}
                    </li>
                  ))}
                </ul>

                <a
                  href="#kontakt"
                  className="mt-auto inline-flex items-center gap-1.5 pt-8 text-sm font-semibold text-[#C5A059] transition-colors duration-200 hover:text-white"
                >
                  Projekt anfragen
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
